import { Typography, Box } from "@mui/material";
import { CustomArrowTitle } from "./custom-arrow-title";
import promptDiagram from "../../../shared/asserts/prompt_diagram.png";

export const PromptInfo = () => {
  return (
    <Box
      sx={{
        margin: "0 auto",
        padding: 2,
      }}
    >
      <Typography variant="h5" fontWeight="bold" gutterBottom align="center">
        Introduction to Prompt Engineering
      </Typography>
      <Typography variant="subtitle1" paragraph align="center">
        Understanding the Basics of Conversational AI and Unveiling the Insights
        You Need.
      </Typography>
      <CustomArrowTitle text={"Prompt Engineer Guide"} />
      <Box sx={{ ml: 4 }}>
        <ol>
          <li>
            <Typography variant="body1">
              Use the text box to ask the Conversational AI your questions.
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              While typing, some terms will be suggested to you:
            </Typography>
            <ul>
              <li>
                <Typography variant="body1">
                  <b>Blue</b>: Indicates <b>KPIs</b>.
                </Typography>
              </li>
              <li>
                <Typography variant="body1">
                  <b>Orange</b>: Indicates <b>hotel dimensions</b>.
                </Typography>
              </li>
            </ul>
          </li>
          <li>
            <Typography variant="body1">
              These highlights help the chatbot better understand your
              underlying questions and provide accurate responses.
            </Typography>
          </li>
        </ol>
        <Typography variant="body1">
          For more details, please look at below example:
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          marginTop: "20px",
        }}
      >
        <img
          src={promptDiagram}
          alt="Prompt Image"
          style={{
            maxHeight: "149px",
            objectFit: "contain",
          }}
        />
      </Box>
    </Box>
  );
};
